export default "<div>\n    <input matInput [(ngModel)]=\"society\" (keyup)=\"onChange()\" placeholder=\"{{'FILTERS.BY_SOCIETY.TITLE' | translate}}\">\n</div>"